import styled from 'styled-components';
import {
  EmptyState,
  EmptyStateTitle,
  IconBrowse,
} from '@spotify-internal/encore-web/core';
import { useT } from '@spotify-internal/i18n-core';
import {
  SearchSortField,
  StoredSearchResult,
} from '@hooks/useSearchedAlbums/types';
import { ResultsTable } from '@components/shared/ResultsTable';
import { _spotify_s4mpview_v1_WhoAmIResponse_NamedEntity__Output } from '@generated/grpc/spotify/s4mpview/v1';

export interface RecentlyViewedProps {
  releasesToShow: StoredSearchResult[];
  userFeeds: _spotify_s4mpview_v1_WhoAmIResponse_NamedEntity__Output[];
  userLicensors: _spotify_s4mpview_v1_WhoAmIResponse_NamedEntity__Output[];
  paginationProps: {
    handlePagination: (updatedPage: number) => void;
    handleLimitChange: (updatedLimit: number) => void;
    limit: string;
    page: string;
  };
  gaEvents: {
    handleTableRowClick: () => void;
    handleClickCopyReleaseId: () => void;
    handleClickCopyURI: () => void;
    handleExpandTerritoriesClick: (prev: boolean) => void;
    handleLiveInTerritoriesApiRetry: () => void;
    handleSortClick?: (
      fieldName: SearchSortField,
      direction: 'ascending' | 'descending',
    ) => void;
    handlePaginationClick?: (actionType: 'increment' | 'decrement') => void;
    handleLimitChange?: (newValue: number) => void;
  };
}

const StyledEmptyState = styled(EmptyState)`
  min-height: 400px;
`;

export const RecentlyViewed = ({
  releasesToShow,
  userFeeds,
  userLicensors,
  paginationProps,
  gaEvents,
}: RecentlyViewedProps) => {
  const t = useT();
  const isFirstPage = Number(paginationProps.page) === 1;

  if (releasesToShow.length === 0 && isFirstPage) {
    return (
      <StyledEmptyState
        icon={IconBrowse}
        maxInlineSize="400px"
        iconColorSet="brightAccent"
        variant="contextual"
      >
        <EmptyStateTitle>
          {t(
            'atlas.recently_viewed.empty_state_title',
            'The releases you view will appear here. ',
            'Title for recently viewed section empty state.',
          )}
        </EmptyStateTitle>
      </StyledEmptyState>
    );
  }

  return (
    <ResultsTable
      results={releasesToShow}
      gaEvents={gaEvents}
      userFeeds={userFeeds}
      userLicensors={userLicensors}
      paginationProps={{
        handlePagination: paginationProps.handlePagination,
        handleLimitChange: paginationProps.handleLimitChange,
        resultLimit: paginationProps.limit,
        currentPage: paginationProps.page,
      }}
    />
  );
};
